import { render, staticRenderFns } from "./MyCstmrRegSet.vue?vue&type=template&id=9235f8c0&scoped=true&"
import script from "./MyCstmrRegSet.vue?vue&type=script&lang=js&"
export * from "./MyCstmrRegSet.vue?vue&type=script&lang=js&"
import style0 from "./MyCstmrRegSet.vue?vue&type=style&index=0&id=9235f8c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9235f8c0",
  null
  
)

export default component.exports